<template>
  <div class="topDiv" style="overflow-x: hidden; height: 100vh">
    <el-row style="height: 100%">
      <el-col style="height: 100%" class="leftMenus" :span="4">
        <CompayMenus :menuIndex="menuIndex" />
      </el-col>

      <el-col :span="20" class="setPadding">
        <el-row class="whiteBox"></el-row>
        <div class="mainContent">
          <el-row class="setPageWidth" style="margin-top: -80px">
            <el-col :span="4" class="positionFont">职位管理</el-col>
            <el-col :span="20" class="setPageWidth">
              <RightMenus />
            </el-col>
          </el-row>

          <el-row class="setPageWidth">
            <el-col class="marginTopButton">
              <el-row>
                <el-col
                  :span="4"
                  class="pulishJob"
                  @click.native="goPageUrl(index, $event, '/pcPulishPosition')"
                  ><span>发布职位</span></el-col
                >

                <el-col :offset="10" :span="4">
                  <el-input
                    placeholder="搜索"
                    v-model="sreachValue"
                    @change="handleCommand"
                    size="small"
                  >
                    <i slot="suffix" class="el-input__icon el-icon-search"></i>
                  </el-input>
                </el-col>
                <el-col :offset="1" :span="3" style="text-align: right">
                  <el-select
                    ref="salary"
                    class="search-input1 null-input input"
                    v-model="selectCage"
                    @change="handleCommand"
                  >
                    <el-option label="全部分类" value="all"></el-option>
                    <el-option
                      v-for="(item, index) in positionType"
                      :key="index"
                      :label="item"
                      :value="item"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="3" style="text-align: right">
                  <el-select
                    ref="salary"
                    class="search-input1 null-input input"
                    v-model="selectStatus"
                    @change="handleCommand"
                  >
                    <el-option label="全部状态" value="all"></el-option>
                    <el-option label="打开的职位" value="1"></el-option>
                    <el-option label="关闭的职位" value="0"></el-option>
                    <el-option label="驳回修改中" value="2"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>

            <div
              v-if="positionList.length == 0"
              style="width: 1200px; height: 200px; text-align: center"
            >
              <div>
                <img
                  style="
                    width: 181px;
                    height: 152px;
                    opacity: 0.3;
                    margin: 50px 0 0 0;
                  "
                  src="@/assets/pcImage/no_data.png"
                  alt=""
                />
                <div style="margin-top: -45px">
                  <span style="color: #f82b18; font-size: 14px"
                    >暂未发布职位</span
                  >
                </div>
              </div>
            </div>
            <el-col v-else v-for="(item, index) in positionList" :key="index">
              <PositionMsg :posMsg="item" class="msgMargin" />
            </el-col>
          </el-row>
        </div>
      </el-col>
    </el-row>
  </div>
</template>
<script>
import RightMenus from "@/components/company/RightMenus.vue";
import CompayMenus from "@/components/company/CompayMenus.vue";
import PositionMsg from "@/components/company/PositionMsg.vue";
import { getAction, postAction, putAction } from "@/comm/manage";
import Vue from "vue";
export default {
  name: "",
  components: {
    RightMenus,
    CompayMenus,
    PositionMsg,
  },
  data() {
    return {
      menuIndex: 1,
      sreachValue: null,
      userInfo: this.$store.state.users.userInfo,
      positionType: null,
      positionList: [],
      selectStatus: "all",
      selectCage: "all",
      url: { list: "/position/tsCompanyPosition/getCompanyPositionList" },
      selectPostion: [
        { label: "全部职位", value: "all" },
        { label: "运营", value: "在职-考虑机会" },
        { label: "当前已发布的所有职位归属", value: "在职-月内到岗" },
      ],
    };
  },
  methods: {
    handleCommand() {
      this.getCompanyPositionList();
    },
    changeClass(index) {
      this.menuIndex = index;
      //加载不同类型残疾人数据
    },
    goPageUrl(index, event, url) {
      this.$router.push(url);
    },
    getCompanyPositionList() {
      let params = {
        cpComId: this.userInfo.ucComId,
        uipType: 3,
        pageSize:100
      };
      if (this.selectStatus != "all") {
        params.cpIsUse = parseInt(this.selectStatus);
      }

      
      if (this.selectCage != "all") {
        params.cpJobType = this.selectCage;
      }
      if (this.sreachValue) {
        params.cpPositionName = this.sreachValue;
      }
      getAction(this.url.list, params).then((res) => {
        if (res.success) {
          this.positionList = res.result;
          console.log(this.positionList);
          this.getPublishPositionType(this.positionList);
        }
        if (res.code === 510) {
          this.$message.warning(res.message);
        }
      });
    },
    getPublishPositionType(arrays) {
      if (arrays) {
        let newArr = new Set();
        for (let i = 0; i < arrays.length; i++) {
          newArr.add(arrays[i].cpJobType);
        }
        this.positionType = Array.from(newArr);
      }
    },
  },
  created: function () {
    this.$store.dispatch("setIsShowHead", false);
    this.getCompanyPositionList("all");
  },
};
</script>
<style lang="stylus" scoped>
.topDiv {
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  height: 100%;
  background-color: #F0F2F5;
  margin: 0 auto;

  .setPadding {
    padding: 0 0 0 260px;
    width: 100%;
  }

  .search-input input.el-input__inner {
    border: 0px solid #f82b18;
  }

  .search-input1 input.el-input__inner {
    border: 0px solid #f82b18;
    height: 20px;
    background-color: white;
    color: black;
  }

  .null-input >>> .el-input__inner {
    background-color: #F0F2F5;
    color: #606266;
    height: 44px;
    border-radius: 0;
    border-width: 0px;
    font-size: 14px;
    line-height: 44px;
  }

  .input ::-webkit-input-placeholder {
    color: black;
    font-family: 'SourceHanSansCN';
    font-size: 13px;
  }

  .input ::-moz-placeholder {
    color: black;
    font-family: 'SourceHanSansCN';
    font-size: 13px;
  }

  .input ::-ms-input-placeholder {
    color: black;
    font-family: 'SourceHanSansCN';
    font-size: 13px;
  }

  .whiteBox {
    box-shadow: 0px 0px 10px 0px rgba(0, 0, 0, 0.1);
    background: #fff;
    height: 64px;
  }

  .positionFont {
    height: 64px;
    line-height: 64px;
  }

  .leftMenus {
    position: fixed;
    width: 256px;
    height: 100%;
    top: 0;
    z-index: 100;
    box-shadow: 1px 0 5px rgba(0, 0, 0, 0.05);
    background: #252830;
  }

  .setPageWidth {
    max-width: 1180px;
    margin: 0 auto;

    .pulishJob {
      width: 88px;
      height: 32px;
      background: #f82b18;
      border-radius: 6px;
      font-size: 14px;
      font-weight: 400;
      color: rgba(255, 255, 255, 1);
      line-height: 32px;
      text-align: center;
      margin-top: 20px;
      cursor: pointer;
    }

    .marginTopButton {
      margin: 10px 0 11px 0;
    }
  }

  .msgMargin {
    margin-top: 16px;
  }

  .mainContent {
    padding: 15px 40px 15px 40px;
    height: 100%;
    position: relative;
    font-size: 18px;
    line-height: 64px;
    text-align: left;
  }
}
</style>